import { Box } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import * as React from "react";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { getInvoiceById, getOneClient } from "../service/weexpertService";
import { InvoiceForm, MODE } from "@/components/forms/invoice";

const InvoiceViewPage = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [invoice, setInvoice] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      getInvoiceById(id)
        .then(res => {
          setInvoice(res.data);
          return res.data;
        })
        .then(res => {
          if (res.clientId) {
            return getOneClient(res.clientId)
              .then(() => {})
              .catch(error => {
                if (error.response) {
                  console.error("Error fetching client:", error.response.status);
                } else if (error.request) {
                  console.error("Request error:", error.request);
                } else {
                  console.error("Unknown error:", error.message);
                }
              });
          }
        })
        .then(() => {
          setLoading(false);
        })
        .catch(error => {
          if (error.response && error.response.status === 404) {
            if (error.response.data && error.response.data.message === "Not found") {
              navigate('/404');
            }
          } else {
            console.error("Error:", error);
          }
          if (error.response && error.response.status === 400) {
            navigate('/404');
          } else {
            console.error("Error:", error);
          }
        });
    }
  }, [id, navigate]);

  return (
    <Box>
      {loading ? (
        <Box sx={{ width: "100%", height: '80vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Stack sx={{ color: 'grey.500' }} spacing={2} direction="row">
            <CircularProgress color="grey" />
          </Stack>
        </Box>
      ) : (
        <InvoiceForm invoice={invoice} mode={MODE.VIEW} />
      )}
    </Box>
  );
};

export default InvoiceViewPage;
